<template>
  <v-container class="pa-0 ma-0">
    <!-- Individual plots for first and last visit -->
    <v-row class="pa-0 ma-0">
      <v-col cols="6" class="pa-0 ma-0 panel-col right-border">
        <v-card color="#eeeeee" class="pt-1 title-card">
          <v-card-title class="primary--text pl-3 py-2"
            >First Visit
            <v-spacer />
            <v-toolbar-items> </v-toolbar-items>
          </v-card-title>
        </v-card>

        <div fluid fill-height class="ma-0 pa-0">
          <v-row class="pa-0 ma-0">
            <v-col cols="12" class="pa-0 ma-0">
              <b>Visit:</b> {{ firstVisitLabel }}
              <BarChart
                :id="variable.id"
                :dimension-name="`${variable.label} - First Visit`"
                :variable="variable.children[0]"
                :interactive="false"
                @userChangedVariable="userChangedVariable"
              />
            </v-col>
          </v-row>
        </div>
      </v-col>

      <v-col cols="6" class="pa-0 ma-0 panel-col ">
        <v-card color="#eeeeee" class="pt-1 title-card">
          <v-card-title class="primary--text pl-3 py-2"
            >Last Visit
            <v-spacer />
            <v-toolbar-items> </v-toolbar-items>
          </v-card-title>
        </v-card>

        <div fluid fill-height class="ma-0 pa-0">
          <v-row class="pa-0 ma-0">
            <v-col cols="12" class="pa-0 ma-0">
              <b>Visit:</b> {{ lastVisitLabel }}
              <BarChart
                :id="variable.id"
                :dimension-name="`${variable.label} - Last Visit`"
                :variable="variable.children[1]"
                :interactive="interactive"
                :show-filter-help="showFilterHelp"
                @userChangedVariable="userChangedVariable"
              />
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BarChart from '@/components/CohortManager/BarChart/BarChart.vue';

export default {
  components: {
    BarChart,
  },
  props: {
    variable: {
      type: Object,
      required: true,
    },
    dimensionName: {
      type: Number,
      required: true,
    },
    highlightChange: {
      type: Boolean,
      required: false,
    },
    firstVisitLabel: {
      type: String,
      required: false,
      default: 'First Visit',
    },
    lastVisitLabel: {
      type: String,
      required: false,
      default: 'Last Visit',
    },
    interactive: {
      type: Boolean,
      required: false,
      default: true,
    },
    showFilterHelp: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    userChangedVariable() {
      this.$emit('userChangedVariable');
    },
  },
};
</script>

<style lang="scss" scoped>
.title-card {
  width: calc(100% + 12px);
  margin-bottom: 1rem;
}

.panel-col {
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  border-top: 1px solid lightgray;
}

.right-border {
  border-right: 1px solid lightgray;
}
</style>
